
// purge-html.js

import parseDOM from './html-parse-dom'
import isArray from 'lodash/isArray'
import each from 'lodash/each'
import isEqual from 'lodash/isEqual'
import filter from 'lodash/filter'
import map from 'lodash/map'

function purgeDOM(dom) {
  if (isArray(dom)) {
    var children = []
    //console.log('array', dom)
    each(dom, (child)=> children = children.concat(purgeDOM(child)))
    return children
  }

  var attribs = Object.assign({}, dom.attribs)
  if (!attribs.style) delete attribs.style
  if (!attribs.class) delete attribs.class

  if (dom.type == 'tag' &&
      (dom.name == 'div' || dom.name == 'span') &&
      (!attribs || isEqual(attribs, {}) || isEqual(attribs, { contenteditable: 'false' })) &&
      (filter(dom.children, (child)=> {
        var _attribs = Object.assign({}, child.attribs)
        if (!_attribs.style) delete _attribs.style
        if (!_attribs.class) delete _attribs.class
        return child.type == 'tag' && child.name == dom.name && (!_attribs || isEqual(_attribs, {}) || isEqual(_attribs, { contenteditable: 'false' }))
      })).length == dom.children.length) {
    //console.log('tag', dom)
    var children = purgeDOM(dom.children)
    each(purgeDOM(children), (child, i)=> {
      child.prev = (i == 0 ? null : children[i - 1])
      child.next = (i == children.length - 1 ? null : children[i + 1])
      child.parent = dom.parent
    })
    return children
  }

  if (dom.type == 'text') 
    return dom

  else {
    //console.log('else', dom)
    dom.children = purgeDOM(dom.children)
    return dom
  }
}

const ELEMENT_TAGS = {
  img: true,
  input: true,
  br: true,
}

function stringifyDOM(dom) {
  if (isArray(dom))
    return map(dom, (child)=> stringifyDOM(child)).join('')

  if (dom.type == 'text')
    return dom.data

  if (dom.children && dom.children.length > 0)
    return `<${dom.name}${map(dom.attribs, (v, k)=> ` ${k}="${v}"`).join('')}>` +
        stringifyDOM(dom.children) + `</${dom.name}>`

  if (ELEMENT_TAGS[dom.name])
    return `<${dom.name}${map(dom.attribs, (v, k)=> ` ${k}="${v}"`).join('')}>`
  else if (dom.attribs.length > 0)
    return `<${dom.name}${map(dom.attribs, (v, k)=> ` ${k}="${v}"`).join('')}></${dom.name}>`
  else return ''
}

export default function purgeHtml(html) {
  const dom = parseDOM(html)
  const pdom = purgeDOM(dom)
  return stringifyDOM(pdom)
}



// WEBPACK FOOTER //
// ./src/helpers/purge-html.js